module.exports = __webpack_public_path__ + "media/images/sp/specials/common/frequent/dummy-17b37e09052a93f8edceeb0052ff1303.jpg";